import { lazy } from 'react';
import TableColumn from './TableColumn';
import TableCaption from './TableCaption';

const Table = lazy(() =>
  import(/* webpackChunkName: "component-table" */ './Table'));
const TablePorto = lazy(() =>
  import(/* webpackChunkName: "component-table-porto" */ './TablePorto'));
const TableTransaction = lazy(() =>
  import(
    /* webpackChunkName: "component-table-transaction" */ './TableTransaction'
  ));

export { TableColumn, TableCaption, Table, TablePorto, TableTransaction };
